// extracted by mini-css-extract-plugin
module.exports = {"item":"ContactList_item__2O1QO","name":"ContactList_name__1Ky0q","button":"ContactList_button__2ddkH"};